import { render, staticRenderFns } from "./AutoInformSetting.vue?vue&type=template&id=ad968618&scoped=true&"
import script from "./AutoInformSetting.vue?vue&type=script&lang=js&"
export * from "./AutoInformSetting.vue?vue&type=script&lang=js&"
import style0 from "./AutoInformSetting.vue?vue&type=style&index=0&id=ad968618&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad968618",
  null
  
)

export default component.exports